import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var MovingTruckSVG = function MovingTruckSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("rect", {
    className: "DetailedIcon__no-fill",
    x: "10.27",
    y: "9.27",
    width: "15.86",
    height: "2.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M12.95,24.01a4.744,4.744,0,0,0-.92,1.12H10.27v-1.2H12.5A1.33,1.33,0,0,1,12.95,24.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M2,16.433v1.5H3.5A1.5,1.5,0,0,1,2,16.433Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M39.85,33.933H40a2.006,2.006,0,0,0,2-2v-.27A2.22,2.22,0,0,1,39.85,33.933Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M39.73,20.6v4.53H39.1a4.5,4.5,0,0,0-7.8,0H19.84a4.493,4.493,0,0,0-6.89-1.12,1.33,1.33,0,0,0-.45-.08H10.27V20.6h10.2a1.135,1.135,0,0,0,0-2.27H10.27v-6.4H26.13v7.54a1.137,1.137,0,0,0,1.14,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M8,14.93v3H3.5a1.5,1.5,0,0,1,0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M42,25.53v6.13a2.22,2.22,0,0,1-2.15,2.27H10a.86.86,0,0,1-.16-.01c-.03,0-.06-.01-.09-.01a1.964,1.964,0,0,1-.88-.33,2.2,2.2,0,0,1-.18-.14,2.047,2.047,0,0,1-.31-.35c-.01-.02-.03-.03-.04-.05s-.03-.06-.05-.09a1.344,1.344,0,0,1-.12-.24,1.142,1.142,0,0,1-.09-.26A2.048,2.048,0,0,1,8,31.89V28.93a1.993,1.993,0,0,1,1.1-1.77,1.988,1.988,0,0,0,.94.24H11.4a4.535,4.535,0,0,0,9.07,0h10.2a4.53,4.53,0,0,0,9.06,0,2.277,2.277,0,0,0,2.26-2.15C42,25.36,42,25.45,42,25.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M8,20.93v3H4.5a1.5,1.5,0,0,1,0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M39.73,18.33l-3.88-5.65a2.257,2.257,0,0,0-1.97-1.15H28.4V9.04A2.049,2.049,0,0,0,26.36,7H10.04A2.049,2.049,0,0,0,8,9.04V25.36a2.039,2.039,0,0,0,1.1,1.8,1.988,1.988,0,0,0,.94.24H11.4a4.535,4.535,0,0,0,9.07,0h10.2a4.53,4.53,0,0,0,9.06,0,2.277,2.277,0,0,0,2.26-2.15c0-.04.01-.08.01-.12V20.6A2.275,2.275,0,0,0,39.73,18.33ZM28.4,13.8h5.48l.1.16,2.75,4,.25.37H28.4ZM15.93,29.67A2.27,2.27,0,1,1,18.2,27.4,2.266,2.266,0,0,1,15.93,29.67Zm19.27,0a2.27,2.27,0,1,1,2.27-2.27A2.275,2.275,0,0,1,35.2,29.67Zm4.53-4.54H39.1a4.5,4.5,0,0,0-7.8,0H19.84a4.493,4.493,0,0,0-6.89-1.12,4.744,4.744,0,0,0-.92,1.12H10.27V20.6h10.2a1.135,1.135,0,0,0,0-2.27H10.27V9.27H26.13v10.2a1.137,1.137,0,0,0,1.14,1.13H39.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "DetailedIcon__accent-color-fill",
    points: "36.98 18.33 28.4 18.33 28.4 13.8 33.88 13.8 33.98 13.96 36.73 17.96 36.98 18.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M3,22.433a1.5,1.5,0,0,1,1.5-1.5H2v3H4.5A1.5,1.5,0,0,1,3,22.433Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "DetailedIcon__no-fill",
    x: "2",
    y: "26.933",
    width: "4",
    height: "0.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M7.75,33.913a1.964,1.964,0,0,1-.88-.33A1.607,1.607,0,0,0,7.75,33.913Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M6,26.933v.02H7.77a1.785,1.785,0,0,1,.23-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M30.5,35.933h-12a1.5,1.5,0,0,0,0,3h12a1.5,1.5,0,0,0,0-3Z"
  }));
};
MovingTruckSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
MovingTruckSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "MovingTruck")
};
export default withDetailedIcon(MovingTruckSVG);